import React from 'react';
import { OpenInNew } from '@mui/icons-material';

interface CompanyInfoDetailProps {
  desc: string | undefined;
  icon: JSX.Element;
  className?: string;
  isHyperlink?: boolean;
  title?: string;
}

export default function CompanyInfoDetail({desc, icon, className, isHyperlink, title}: CompanyInfoDetailProps) {
  return (
    <>
      {
        desc && desc !== 'Not disclosed' &&
          <span className={`flex gap-2 items-top w-fit ${className}`} title={title}>
            {icon}
            {
              !isHyperlink &&
              <span className={'-mt-1'}>{desc}</span>
            }
            {
              isHyperlink && <a
                href={desc}
                className={'-mt-1'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                <span>{desc}</span>{' '}
                <OpenInNew />
              </a>
            }
          </span>
      }
    </>
  );
}
